import { render, staticRenderFns } from "./escortList.vue?vue&type=template&id=4ec65040&scoped=true&"
import script from "./escortList.vue?vue&type=script&lang=js&"
export * from "./escortList.vue?vue&type=script&lang=js&"
import style0 from "./escortList.vue?vue&type=style&index=0&id=4ec65040&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec65040",
  null
  
)

export default component.exports